import { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

export function firstValueOrDefault<T, D>(source: Observable<T>, defaultValue: D): Promise<T | D> {
  return firstValueFrom(source, { defaultValue });
}

export function firstValueOrUndefined<T>(source: Observable<T>): Promise<T | undefined> {
  return firstValueFrom(source, { defaultValue: undefined });
}

export function firstValueOrNull<T>(source: Observable<T>): Promise<T | null> {
  return firstValueFrom(source, { defaultValue: null });
}
